import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Auth from './auth/Auth';
import FinishLogin from './FinishLogin';
import { useError } from '../shared/context/ErrorContext';

const Unauthenticated: React.FC = () => {
  const { error } = useError();

  return (
    <Routes>
      <Route path="/auth" element={<Auth />} />
      <Route 
        path="/finishLogin" 
        element={error ? <Navigate to="/auth" /> : <FinishLogin />} 
      />
      <Route path="/" element={<Navigate to="/auth" />} />
    </Routes>
  );
};

export default Unauthenticated;
